import { render } from "./StudioNews.vue?vue&type=template&id=7876a539"
import script from "./StudioNews.vue?vue&type=script&lang=js"
export * from "./StudioNews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__